import styled from 'styled-components';

type Props = {
  isDisabled: boolean;
};

const Wrapper = styled.div<Props>`
  width: fit-content;
  height: 44px;
  display: flex;
  background: ${(props) => props.theme.colors.widget_background};
  border-radius: 6px;
  opacity: ${(props) => props.isDisabled && '0.5'};
  cursor: ${(props) => (props.isDisabled ? 'wait' : 'default')};

  .entity-preview {
    display: flex;
    align-items: center;
    gap: 0;
    width: fit-content;

    .avatar {
      img {
        border-radius: 6px 0 0 6px;
        width: 44px;
        height: 44px;
        object-fit: cover;
      }
    }

    .description {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding: 0 8px 0 8px;

      .title {
        font-size: 16px;
        padding-bottom: 4px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        min-width: 5ch;
        max-width: 15ch;
      }

      .subtitle {
        font-size: 13px;
        color:  ${(props) => props.theme.colors.inactive};
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        min-width: 5ch;
        max-width: 15ch;
      }
    }
  }
  
  .unassign-btn {
    font-family: ManropeBold, sans-serif;
    font-size: 13px;
    padding: 13px 16px 13px 20px;
    border-left: ${(props) => `1px solid ${props.theme.colors.outline}`};
    
    &:hover {
      color: ${(props) => props.theme.colors.main_cta};
    }
    
    &:disabled {
      cursor: initial;
    }
  }
`;

export default { Wrapper };
